<template>

  <div class="Rebate">
    <b-overlay :show="show" spinner-variant="primary" spinner-large rounded="sm" style="height:100vh" variant="dark"
      id="loader">
      <b-row>
        <b-col cols="12 headerF">
          <HeaderFixed />
        </b-col>
        <b-col cols="12 headerM">
          <HeaderMobile />
        </b-col>
      </b-row>
      <b-container id="consBillDiv" fluid style="padding-top: 100px;text-align:left">

        <b-row>
          <b-col cols="12">
            <b-breadcrumb style=" background-color: #e9ecef78;">
              <b-breadcrumb-item href="#home">
                <router-link to="/">
                  <b-icon icon="house-door" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon>
                  Home
                </router-link>
              </b-breadcrumb-item>
              <b-breadcrumb-item href="ActsAndRules">Acts & Policies</b-breadcrumb-item>

              <b-breadcrumb-item href="#" active>Renewable Projects Related Information</b-breadcrumb-item>
            </b-breadcrumb>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <h1 class="heading">Renewable Projects Related Information</h1>
          </b-col>

        </b-row>
        <div class="paddingLeft30px">
          <div id="renewableEnergyPolicyDetails" style="width:90vw;font-size:0.8rem">
            <br />
            <b-table :items="renewableEnergyList" :fields="RenewableEnergyFields" bordered striped hover small>
              <template v-slot:cell(name)="data">
                <a :href="$urlCommon + '/' + data.item.file_location" target="_blank" class="d-flex align-items-center">
                  <img :src="$urlCommon + '/assets/pdf-icon-3.png'" height="30" width="30" style="margin-right: 8px;"
                    alt="PDF" />
                  <span>{{ data.item.name }}</span>
                </a>
              </template>
            </b-table>
          </div>

          <br>

          <br>

        </div>
      </b-container>

      <br><br>
    </b-overlay>

  </div>

</template>


<script>

import HeaderFixed from '@/components/HeaderFixed.vue'
import HeaderMobile from '@/components/HeaderMobile.vue'
import axios from 'axios'
var thColor = '#0288d1';
export default {
  name: 'RenewableEnergyPolicy',
  components: {
    'HeaderFixed': HeaderFixed,
    'HeaderMobile': HeaderMobile
  },

  data() {
    return {
      RenewableEnergyFields: [
        { key: 'name', label: 'Particulars', thStyle: { width: '80vw' } }

      ],
      show: false,
      renewableEnergyList: []
    }
  },
  mounted() {
    this.getRenewableEnergyReport();
  },
  methods: {
    getRenewableEnergyReport() {
      this.show = true;
      axios.get(this.$urlCommon + "/api/web/document")
        .then((response) => {
          if (response.data && response.data.document) {
            this.renewableEnergyList = response.data.document.filter(
              item => item.sub_type === 42 && item.active === 'Y'
            );
          }
        })
        .catch((error) => {
          console.error("Error fetching renewable energy data:", error);
          this.renewableEnergyList = [];
        });
      this.show = false;
    }
  },
}
</script>

<style scoped="true">
/* edob style */
li {
  padding: 0;
}

body {
  overflow-y: hidden;
}

.heading {
  border-left: 10px solid #ed7c27;
  border-left-width: 10px;
  border-left-style: solid;
  border-left-color: rgb(237, 124, 39);
  font-size: 25px;
  text-align: left;
  letter-spacing: 1px;
  padding-left: 1rem;
  margin-bottom: 2rem;
  margin-top: 1rem;
  text-transform: capitalize;

}

.content {
  text-align: justify;
  line-height: 1.5rem;
  font-size: 0.9rem;
}

.cntnt {
  box-shadow: 0 -2px 15px 0 rgba(0, 0, 0, 0.2), 0 10px 10px 0 rgba(0, 0, 0, 0.19);
  padding: 10px 30px 10px 30px;


}

table {
  text-align: left !important;
}

.headerF {
  display: block;
}

.headerM {
  display: none;
}

@media (max-width: 768px) {
  .headerF {
    display: none;
  }

  .headerM {
    display: block;
  }
}

/* edob style */


.paddingRow {
  padding: 0.7rem;
}

.paddingCol {
  padding: none;
}

.label {
  font-weight: 600;
}

.data {
  font-weight: 600;
  color: #ff5722;
  font-size: 1.5rem;
}

.hideDetails {
  visibility: hidden;
  opacity: 0;
  transition: visibility 0s, opacity 0.5s linear;
  box-shadow: 2px 2px 10px 2px #bdbdbd;
  padding: 1rem;
  margin-right: 1.5rem;
}

.showDetails {

  visibility: visible;
  opacity: 1;
}

hr {
  margin-top: 5px;
  margin-bottom: 5px;
}

.go:focus {
  box-shadow: none;
}

.headerF {
  display: block;
}

.headerM {
  display: none;
}

.paddingLeft30px {
  padding-left: 30px;
}

@media (max-width: 768px) {
  .headerF {
    display: none;
  }

  .headerM {
    display: block;
  }

  .paddingLeft30px {
    padding-left: 0px;
  }
}

@media only screen and (max-width: 414px) {
  .paddingCol {
    padding: 0.7rem;
  }

  .paddingRow {
    padding: none !important;
  }

  .paddingLeft30px {
    padding-left: 0px;
  }
}
</style>
